import React, { Component } from 'react';
import cIf from 'classnames';
import PT from 'prop-types';
import { accounting } from 'accounting';
import { NoItem } from '../easyctl';
import { MainPaging } from '../paging';
import { constant, startsWith, merge, round, take, drop, includes } from 'lodash';
import { ProcessingItem } from '../ts-common-react-controls';
import { TablePlaceHolder } from '../placeholder/tableplaceholder';

const moment = require('moment-timezone');

const up = require('react-addons-update');

const PLACEHOLDER_ROW_HEIGHT = 36;

const lcaseFind = function(str, lcaseFind) {
    return includes(str.toLowerCase(), lcaseFind) === true;
};

const contentFilteringFunc = function(item, field, filter) {
    return lcaseFind(field.getContent(item, field).toString(), filter.str);
};


const readDictOrDefaultKey = function(dict, key, defaultKey) {
    const retVal = dict[key];
    if(retVal === undefined)
        return dict[defaultKey];
    return retVal;
};

const getHelpText = function(_item, _name) {
    return _item ? _item[_name] : "";
};

export class ItemTable extends Component {
    constructor(props) {
        super(props);
        
        this.state = {
            currentPage: 0,
            filtering: false
        };

        this.handlePageChange = this.handlePageChange.bind(this);
        this.handleItemClick = this.handleItemClick.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (this.props.filterText !== prevProps.filterText) {
            this.setState({filtering: this.props.filterText.length > 0});
        }
    }

    getContentFuncByType() {
        const _this = this;
        return {
            object: function(item, field) { return parseContent(item, field); },
            datetime: function(item, field) {
                const val = item[field.name];
                if(val !== null) {
                    const date = (field.tz !== undefined) ? moment.tz(val, field.tz) : moment(val);
                    return date.format(_this.props.dateTimeFormat);
                }
                return "";
            },
            bool: function(item, field) { return item[field.name] ? "✓" : ""; },
            money: function(item, field) { return item[field.name] ? accounting.formatMoney(item[field.name]) : ""; }
        };
    }

    cellCSSByType = {
        object: '',
        datetime: 'datetime',
        bool: 'bool'
    };
    
    getFilteringFuncByType() {
        return {
            object: contentFilteringFunc,
            datetime: contentFilteringFunc,
            bool: function(item, field, filter) {
                // Since we cannot compare a check box. We compare with the title. If it matches we return the real bool, else, false.
                const inTitle = lcaseFind(field.title, filter.str);
                return inTitle ? item[field.name] : false;
            }
        };
    }

    upgradeField(field, fieldName) {
        const curF = up(field, { name: { $set: fieldName } });
        if(curF.visible === undefined) curF.visible = true;
        if(curF.isKey === undefined) curF.isKey = false;
        if(curF.title === undefined) curF.title = "";
        if(curF.type === undefined) curF.type = "object";
        if(curF.filter === undefined) curF.filter = curF.visible; // Field is visible by default IF visible...
        if(curF.getContent === undefined) curF.getContent = readDictOrDefaultKey(this.getContentFuncByType(), curF.type, 'object');
        if(curF.cssClass === undefined) curF.cssClass = readDictOrDefaultKey(this.cellCSSByType, curF.type, 'object');
        if(curF.filterItem === undefined) curF.filterItem = readDictOrDefaultKey(this.getFilteringFuncByType(), curF.type, 'object');
        if(curF.getHelpText === undefined) curF.getHelpText = getHelpText;
        return curF;
    }

    // Build the filters 
    buildFilters(filterStr) {
        const trimedFilterText = filterStr.trim().toLowerCase();
        
        const filterTexts = trimedFilterText.length > 0 ? trimedFilterText.split(' ') : [];

        const retFilteringKit = {
            includeFilters: [],
            excludeFilters: []
        };

        filterTexts.forEach((item) => {
            // If the filter starts with a slash, it's a not!
            const filterObj = {
                not: startsWith(item, "/")
            };

            filterObj.str = filterObj.not ? item.substr(1, item.length - 1) : item;
            
            if(filterObj.not)
                retFilteringKit.excludeFilters.push(filterObj);
            else
                retFilteringKit.includeFilters.push(filterObj);
        });

        retFilteringKit.hasFilters = retFilteringKit.includeFilters.length > 0 || retFilteringKit.excludeFilters.length > 0;

        return retFilteringKit;
    }

    handlePageChange(page) {
        this.setState({ currentPage: page });
    }

    handleItemClick(item) {
        if(this.props.onItemClick)
            this.props.onItemClick(item);
    }
    
    render() {   
        const _this = this;
        
        let header = null,
            body = null,
            footer = null,
            paging = null;

        // Filter/Prepare the fields
        const vFields = [];
        const filteredFields = [];
        let keyField = null;

        Object.keys(this.props.fields).forEach((item) => {
            const curF = this.upgradeField(this.props.fields[item], item);

            if(curF.visible)
                vFields.push(curF);
            
            if(curF.filter)
                filteredFields.push(curF);
            
            if(curF.isKey)
                keyField = curF;
        });

        // TODO : Build the header
        const headerTDs = vFields.map((field) => {
            let cssClass = field.cssClass;

            let style = {};

            if (_this.props.centerHeader)
                cssClass += ' centered';

            if (field.colWidth)
                style = merge(style, {
                    width: field.colWidth
                });

            if (field.textAlign)
                style = merge(style, {
                    textAlign: field.textAlign
                });

            return <td key={field.name} className={cssClass} style={style}>{field.title}</td>;
        });

        if(!this.props.hideHeader)
            header = <tr>{headerTDs}</tr>;

        // Build the body:
        if(this.props.specialMessage !== null)
            body = <tr><td colSpan={headerTDs.length}>{this.props.specialMessage}</td></tr>;
        else {
            // Filter the rows
            let filteredItems;

            // Split the keywords
            let filteringKit = this.buildFilters(this.props.filterText);

            // If we really have something a filter to apply
            if(filteringKit.hasFilters){
                filteredItems = this.props.items.filter(function(item){
                    let keep = true;
                    // Include filters
                    if(filteringKit.includeFilters.length > 0){
                        // Check each keywords, if one is not found, stop and return false.
                        // eslint-disable-next-line no-loops/no-loops
                        for (const filter of filteringKit.includeFilters) {
                            let foundInOneCol = false;
                            // eslint-disable-next-line no-loops/no-loops
                            for (const field of filteredFields) {
                                // Test all fields here...
                                if(field.filterItem(item, field, filter)) {
                                    foundInOneCol = true;
                                    break;
                                }
                            }
                            if(!foundInOneCol){
                                keep = false;
                                break;
                            }
                        }
                    }

                    // Exlude filters
                    if(keep){
                        // Check each keywords, if one is found, stop and return false.
                        // eslint-disable-next-line no-loops/no-loops
                        for (const filter of filteringKit.excludeFilters) {
                            let foundInOneCol = false;
                            // eslint-disable-next-line no-loops/no-loops
                            for (const field of filteredFields) {
                                // Test all fields here...
                                if(field.filterItem(item, field, filter)) {
                                    foundInOneCol = true;
                                    break;
                                }
                            }
                            if(foundInOneCol){
                                keep = false;
                                break;
                            }
                        }
                    }
                    return keep;
                });
            } else
                filteredItems = this.props.items; // Else, nothing to filter

            let curPageItems = filteredItems;
            
            // Paging
            let curAllowedPage = 0;
            if(this.props.paging) {
                const lastPage = round(filteredItems.length / this.props.itemPerPage); // Zero based
                if (!this.state.filtering)
                    curAllowedPage = (this.state.currentPage >= lastPage) ? lastPage : this.state.currentPage;
                
                curPageItems = take(
                    drop(filteredItems, curAllowedPage * this.props.itemPerPage),
                    this.props.itemPerPage);
                }
                
                // Build the items
                if(this.props.processing){
                    body = <tr><td colSpan={headerTDs.length}><ProcessingItem /></td></tr>;
                }
                else{
                    body = [];
                    if(this.props.itemsBefore && curPageItems.length > 0){
                        body = this.props.itemsBefore.map((item, index) => {
                        // eslint-disable-next-line sonarjs/no-array-index-key
                        return <tr className={'smoothRendering'} key={`rows_${index}`}><td key={index} colSpan={vFields.length}>{item}</td></tr>;
                    });
                }

                const items = curPageItems.map(function(item){
                    const isSelected = _this.props.checkIsSelected(item);
                    const onClick = (_this.props.clickableItem && !isSelected) ? function() { _this.handleItemClick(item); }  : null;

                    return(
                        <tr key={item[keyField.name]} className={'smoothRendering ' + cIf({ selected: isSelected })} onClick={onClick}>
                            {
                                vFields.map(function (field) {
                                    let style = {};
                                    if (field.textAlign)
                                        Object.assign(style, {textAlign: field.textAlign});

                                    return(
                                        <td key={field.name} className={field.cssClass} style={style} title={field.getHelpText(item, field)}>{field.getContent(item, field)}</td>
                                    );
                                })
                            }
                        </tr>
                    );
                });

                body.push(items);
            }

            if (this.props.paging) {
                paging = <MainPaging itemQty={filteredItems.length} currentPage={curAllowedPage} itemPerPage={this.props.itemPerPage} onChange={this.handlePageChange} />;
            }       
        }
        
        /*<td>{_this.formatDate(item.StartDate)}</td>
                        <td>{_this.formatDate(item.EndDate)}</td>
                        <td>{item.IsVisibleOnInternetSale ? "visible" : "caché"}</td>
                        <td>{item.IsPromo ? "promo" : "régulier"}</td>*/

        const bodyStyle = {};

        if (this.props.bodyFontSize)
            Object.assign(bodyStyle, {fontSize: this.props.bodyFontSize});

        const itemTableStyle = {};

        if(this.props.showPlaceHolder){
            const rowCount = this.props.placeHolderRow ?? this.props.itemPerPage;
            Object.assign(itemTableStyle, {minHeight: rowCount * PLACEHOLDER_ROW_HEIGHT});
        }

        return <>
            <div className="itemTable" style={itemTableStyle}>
                <table>
                    <thead>
                        {header}
                    </thead>
                    <tbody className={cIf({ clickable: this.props.clickableItem })} style={bodyStyle}>
                        {this.props.showPlaceHolder ? <TablePlaceHolder 
                            processing={this.props.processing} 
                            rows={this.props.placeHolderRow ?? this.props.itemPerPage}
                            childrens={body}
                            cols={vFields.length}
                        /> : body}
                    </tbody>
                    <tfoot>
                        {footer}
                    </tfoot>
                </table>
            </div>
            <div>
                {paging}
            </div>
        </>;
    }
}

ItemTable.propTypes = {
    fields: PT.object.isRequired,
    items: PT.array.isRequired,
    itemsBefore: PT.any,
    checkIsSelected: PT.func, // (item -> isSelected)
    specialMessage: PT.node,
    dateTimeFormat: PT.string,
    itemPerPage: PT.number,
    clickableItem: PT.bool, // When the items are clickable, this is the click action
    onItemClick: PT.func, // When the items are clickable
    noItemCtl: PT.node,
    centerHeader: PT.bool,
    hideHeader: PT.bool,
    paging: PT.any,
    bodyFontSize: PT.any,
    processing: PT.bool.isRequired,
    filterText: PT.string,
    showPlaceHolder: PT.bool, //Show placeholder processing
    placeHolderRow: PT.number //Override itemPerpage props for the placeHolder
};

ItemTable.defaultProps = {
    checkIsSelected: constant(false),
    specialMessage: null,
    dateTimeFormat: 'YYYY-MM-DD HH:mm:ss.SSS z',
    clickableItem: false,
    processing: false,
    itemPerPage: 15,
    noItemCtl: <NoItem />,
    filterText: '',
    paging: true,
    centerHeader: false,
    hideHeader: false,
    showPlaceHolder: true
};

function parseContent(item, field) {
    const colWidth = field.colWidth ? field.colWidth.replace(/^d/, ''): 0;

    if(colWidth > 0 && colWidth < 200){
        const text = item[field.name];
        if(text.length > 20)
            return text.substr(0, 20) + '...';
    }

    return item[field.name];
}

